import { __ } from "@wordpress/i18n";
import { useState, useEffect } from "@wordpress/element";
import { dispatch, useSelect } from "@wordpress/data";
import { Button } from "@wordpress/components";
import  BlockCard from "../components/BlockCard";
import {
  accordionIcon,
  buttonsIcon,
  containerIcon,
  countdownIcon,
  googleMapIcon,
  gridIcons,
  imageComparison,
  lottieIcon,
  newsletterIcon,
  paragraphIcon,
  progressIcon,
  postsIcon,
  postCarouseIcon,
  postListIcon,
  searchIcon,
  shapeDividerIcon,
  tabsIcon,
  videoPlayerIcon,
  postGridIcon,
  aiGeneration,
  businessHoursIcon,
  cartIcon,
  circleIcon,
  columnsIcon,
  comparisonTableIcon,
  faIcon,
  flipIcon,
  formIcon,
  headingIcon,
  iconListIcon,
  mapIcon,
  popupIcon,
  reviewIcon,
  sharingIcon,
  sliderIcon,
  alertboxIcon,
} from "../utils/icons";
const SlideVerse = [
  {
    slug: "slideverse/paragraph",
    name: __("Paragraph", "slideverse"),
    icon: paragraphIcon,
    docLink: "https://slideverse.pro",
    released: true,
  },
  {
    slug: "slideverse/grid",
    name: __("Grid", "slideverse"),
    icon: gridIcons,
    docLink: "https://slideverse.pro",
    released: true,
  },
  {
    slug: "slideverse/container",
    name: __("Container", "slideverse"),
    icon: containerIcon,
    docLink: "https://slideverse.pro",
    released: true,
  },
  {
    slug: "slideverse/countdown",
    name: __("Countdown", "slideverse"),
    icon: countdownIcon,
    docLink: "https://slideverse.pro",
    released: true,
  },
  {
    slug: "slideverse/brand-logos",
    name: __("Brand Logos", "slideverse"),
    icon: countdownIcon,
    docLink: "https://slideverse.pro",
    released: true,
  },
  {
    slug: "slideverse/google-maps",
    name: __("Google Maps", "slideverse"),
    icon: googleMapIcon,
    docLink: "https://slideverse.pro",
    released: true,
  },
  {
    slug: "slideverse/tabs",
    name: __("Tabs", "slideverse"),
    icon: tabsIcon,
    docLink: "https://slideverse.pro",
    released: true,
  },
  {
    slug: "slideverse/buttons",
    name: __("Buttons", "slideverse"),
    icon: buttonsIcon,
    docLink: "https://slideverse.pro",
    released: true,
  },
  {
    slug: "slideverse/shape-divider",
    name: __("Shape Divider", "slideverse"),
    icon: shapeDividerIcon,
    docLink: "https://slideverse.pro",
    released: true,
  },
  {
    slug: "slideverse/search",
    name: __("Search", "slideverse"),
    icon: searchIcon,
    docLink: "https://slideverse.pro",
    released: true,
  },
  {
    slug: "slideverse/video",
    name: __("Video", "slideverse"),
    icon: videoPlayerIcon,
    docLink: "https://slideverse.pro",
    released: false,
  },
  {
    slug: "slideverse/newsletter",
    name: __("Newsletter", "slideverse"),
    icon: newsletterIcon,
    docLink: "https://slideverse.pro",
    released: true,
  },
  // {
  //   slug: "slideverse/alertbox",
  //   name: __("Alertbox", "slideverse"),
  //   icon: alertboxIcon,
  //   docLink: "https://slideverse.pro",
  //   released: false,
  // },
  {
    slug: "slideverse/accordion",
    name: __("Accordion", "slideverse"),
    icon: accordionIcon,
    docLink: "https://slideverse.pro",
    released: true,
  },
  {
    slug: "slideverse/progress-bar",
    name: __("Progress bar", "slideverse"),
    icon: progressIcon,
    docLink: "https://slideverse.pro",
    released: false,
  },
  {
    slug: "slideverse/image-comparison",
    name: __("Image Comparison", "slideverse"),
    icon: imageComparison,
    docLink: "https://slideverse.pro",
    released: true,
  },
  {
    slug: "slideverse/post-grid",
    name: __("Post Grid", "slideverse"),
    icon: postsIcon,
    docLink: "https://slideverse.pro",
    released: false,
  },
  {
    slug: "slideverse/post-carousel",
    name: __("Post Carousel", "slideverse"),
    icon: postCarouseIcon,
    docLink: "https://slideverse.pro",
    released: false,
  },
  {
    slug: "slideverse/post-list",
    name: __("Post List", "slideverse"),
    icon: postListIcon,
    docLink: "https://slideverse.pro",
    released: false,
  },
  {
    slug: "slideverse/lottie",
    name: __("Lottie", "slideverse"),
    icon: lottieIcon,
    docLink: "https://slideverse.pro",
    released: true,
  },
].sort((a, b) => a.name.localeCompare(b.name));

/**
 * Dashboard Header component.
 * @param {import('../..').BlockCardHeaderProps} props Component props.
 */
const Header = ({ blocks, onDisableAll, onEnableAll, canDisplayBtn }) => {

	const allEnabled = blocks.every( block => ! block.isDisabled );
	const allDisabled = blocks.every( block => block.isDisabled );

	return <div className="ubs-blocks-header">
		<div className="ubs-blocks-header__left">
			<span>{ __( 'All Blocks', 'slideverse' ) }</span>
		</div>
		{
			canDisplayBtn && (
				<div className="ubs-blocks-header__right">
					<Button variant="secondary" disabled={allDisabled} onClick={onDisableAll} >
						{ __( 'Disable All', 'slideverse' ) }
					</Button>
					<Button variant="primary" disabled={allEnabled} onClick={onEnableAll}>
						{ __( 'Enable All', 'slideverse' ) }
					</Button>
				</div>
			)
		}
	</div>;
};
const Blocks = () => {
  const [blocksStatus, setBlocksStatus] = useState(SlideVerse);
  	const [canShowNotice, canShowNoticeSet] = useState(false);


  const { preferencesHiddenBlocks, isLoading } = useSelect(
    (select) => {
      /**
       * Array of hidden block types.
       * @type {Array<string>|undefined}
       */
      const hiddenBlocks = select("core/preferences")?.get(
        "core",
        "hiddenBlockTypes"
      );

      const isResolving = select("core/preferences").isResolving("get", [
        "hiddenBlockTypes",
      ]);

      return {
        preferencesHiddenBlocks: hiddenBlocks
          ? new Set(hiddenBlocks)
          : undefined,
        isLoading: isResolving,
      };
    },
    [blocksStatus]
  );

  /**
   * Update the WP Option with the new value.
   * @param {import('../..').BlocksToDisableList} blocks Blocks to be updated.
   */
  const sendUpdates = (blocks) => {
    const newPreferencesHiddenBlocks = new Set();

    // Copy the old preferences.
    if (preferencesHiddenBlocks) {
      preferencesHiddenBlocks.forEach((block) => {
        newPreferencesHiddenBlocks.add(block);
      });
    }

    // Add the new preferences.
    blocks.forEach((block) => {
      if (block.isDisabled) {
        newPreferencesHiddenBlocks.add(block.slug);
      } else {
        newPreferencesHiddenBlocks.delete(block.slug);
      }
    });

    dispatch("core/preferences").set("core/edit-post", "hiddenBlockTypes", [
      ...newPreferencesHiddenBlocks,
    ]);
  };

  /**
   * Toggle the block status.
   * @param {string} blockSlug Block slug.
   */
  const toggleBlock = (blockSlug) => {
    const updatedBlocksStatus = blocksStatus.map((block) => {
      if (block.slug === blockSlug) {
        block.isDisabled = !block.isDisabled;
      }

      return block;
    });

    sendUpdates(updatedBlocksStatus);
    setBlocksStatus(updatedBlocksStatus);
    canShowNoticeSet(true);
  };

  /**
   * Disable all blocks and update the WP Option.
   */
  const onDisableAll = () => {
    const updatedBlocksStatus = blocksStatus.map((block) => {
      // if (block.isPro && !slideverseObj.hasPro) {
      //   return block;
      // }

      block.isDisabled = true;

      return block;
    });

    sendUpdates(updatedBlocksStatus);
    setBlocksStatus(updatedBlocksStatus);
    canShowNoticeSet(true);
  };

  /**
   * Enable all blocks and update the WP Option.
   */
  const onEnableAll = () => {
    const updatedBlocksStatus = blocksStatus.map((block) => {
      block.isDisabled = false;

      return block;
    });

    sendUpdates(updatedBlocksStatus);
    setBlocksStatus(updatedBlocksStatus);
    canShowNoticeSet(true);
  };

  /**
   * Initiate the blocks' status.
   */
  useEffect(() => {
    if (isLoading) {
      return;
    }

    const updatedBlocksStatus = blocksStatus.map((block) => {
      if (preferencesHiddenBlocks?.has(block.slug)) {
        block.isDisabled = true;
      } else {
        block.isDisabled = false;
      }

      return block;
    });

    setBlocksStatus(updatedBlocksStatus);
  }, [isLoading]);

  useEffect(() => {
    if (!canShowNotice || isLoading) {
      return;
    }

    dispatch?.("core/notices")?.createNotice(
      "info",
      __("Option Updated.", "slideverse"),
      { isDismissible: true, type: "snackbar", id: "saved-options" }
    );
    canShowNoticeSet(false);
  }, [canShowNotice, preferencesHiddenBlocks, isLoading]);
  return (
    <>
      <Header
        blocks={blocksStatus}
        onDisableAll={onDisableAll}
        onEnableAll={onEnableAll}
        canDisplayBtn={!isLoading}
      />

      <div className="ubs-block-cards">
        {blocksStatus.map((block, index) => {
          return (
            <BlockCard
              key={index}
              block={block}
              isLoading={isLoading}
              onToggle={() => toggleBlock(block.slug)}
            />
          );
        })}
      </div>
    </>
  );
};

export default Blocks;
